import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-new-manage',
  templateUrl: './new-manage.component.html',
  styleUrls: ['./new-manage.component.scss']
})
export class NewManageComponent implements OnInit {

  enrolmentId:any
  enrolData:any

  constructor(private apiService:ApiService,private activatedroute:ActivatedRoute,
              private route:Router) {
    this.activatedroute.paramMap.subscribe(params => { 
      this.enrolmentId = params.get('id'); 
  });
   }

  ngOnInit(): void {
    this.getEnrolById( this.enrolmentId)
  }
  getEnrolById(id){
    this.apiService.getEnrolmentById(id).subscribe((res:any)=>{
      this.enrolData=res.data[0]
      
    })
  }
  back(){
    this.route.navigate(['enrollments/enrollment-list'])
  }
  openTab(id){
    this.route.navigate(['/learn/my-classes',id])
  }
  assignmentByStudent(id){
    this.route.navigate(['/assignments/student-assignments',id])
  }
  openTabProject(id){
    this.route.navigate(['/student-projects',id])
  }
}
